import React, { useState } from 'react';
import * as styles from './styles.scss';

const Input = ({
   id,
   label,
   autoComplete,
   type,
   name,
   error,
   className,
   ...props
}) => {
    const [isPassword, setIsPassword] = useState(true);

    return (
        <div className={styles.wrapper}>
            {
                label &&
                <label htmlFor={id || name} className={styles.label}>
                    {label}
                </label>
            }
            <input
                id={id || name}
                name={name}
                type={isPassword ? 'password' : 'text'}
                autoComplete={autoComplete || 'off'}
                className={styles.input || className}
                {...props}
            />
            <span
                className={styles.eye}
                onClick={() => setIsPassword(!isPassword)}
            >
                {
                    isPassword
                        ?
                        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 8.24976C10.2426 8.24976 11.25 7.2424 11.25 5.99976C11.25 4.75712 10.2426 3.74976 9 3.74976C7.75736 3.74976 6.75 4.75712 6.75 5.99976C6.75 7.2424 7.75736 8.24976 9 8.24976Z" fill="#64665D"/>
                            <path d="M9 -0.000244141C6 -0.000244141 3 1.49976 0 5.99976C3 10.4998 6 11.9998 9 11.9998C12 11.9998 15 10.4998 18 5.99976C15 1.49976 12 -0.000244141 9 -0.000244141ZM9 9.74976C6.93237 9.74976 5.25 8.06812 5.25 5.99976C5.25 3.9314 6.93237 2.24976 9 2.24976C11.0676 2.24976 12.75 3.9314 12.75 5.99976C12.75 8.06812 11.0676 9.74976 9 9.74976Z" fill="#64665D"/>
                        </svg>
                        :
                        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 8.24976C10.2426 8.24976 11.25 7.2424 11.25 5.99976C11.25 4.75712 10.2426 3.74976 9 3.74976C7.75736 3.74976 6.75 4.75712 6.75 5.99976C6.75 7.2424 7.75736 8.24976 9 8.24976Z" fill="#889C51"/>
                            <path d="M9 -0.000244141C6 -0.000244141 3 1.49976 0 5.99976C3 10.4998 6 11.9998 9 11.9998C12 11.9998 15 10.4998 18 5.99976C15 1.49976 12 -0.000244141 9 -0.000244141ZM9 9.74976C6.93237 9.74976 5.25 8.06812 5.25 5.99976C5.25 3.9314 6.93237 2.24976 9 2.24976C11.0676 2.24976 12.75 3.9314 12.75 5.99976C12.75 8.06812 11.0676 9.74976 9 9.74976Z" fill="#889C51"/>
                        </svg>
                }
            </span>
            {!!error && <span className={styles.error}>{error}</span>}
        </div>
    );
};

export default Input;
